export const downloadMac = 'https://openvpn.net/downloads/openvpn-connect-latest.dmg';
export const downloadWindows = 'https://openvpn.net/downloads/openvpn-connect-latest.msi';
export const downloadIos = 'https://itunes.apple.com/us/app/openvpn-connect/id590379981?mt=8';
export const downloadAndroid = 'https://play.google.com/store/apps/details?id=net.openvpn.openvpn';
export const downloadLinux = 'https://openvpn.net/cloud-docs/openvpn-3-client-for-linux/';

export const linuxInstructions = 'https://community.openvpn.net/openvpn/wiki/OpenVPN3Linux';

export const vpnEgress = 'https://openvpn.net/cloud-docs/openvpn-cloud-vpn-egress/';

export const cloudFormation = 'https://openvpn.net/cloud-docs/launch-connector-on-aws/';

export const addingEgress = 'https://openvpn.net/cloud-docs/adding-vpn-egress/';
